import { render, staticRenderFns } from "./MyActiveSubscriptions.vue?vue&type=template&id=790ec4a4&scoped=true&"
import script from "./MyActiveSubscriptions.vue?vue&type=script&lang=js&"
export * from "./MyActiveSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./MyActiveSubscriptions.vue?vue&type=style&index=0&id=790ec4a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ec4a4",
  null
  
)

export default component.exports